import React from "react";
import { Palette, Maximize2, Lightbulb, Layers, DoorOpen } from "lucide-react";
import AnimatedSection from "../common/AnimatedSection";
import SectionHeading from "../common/SectionHeading";

const features = [
  {
    icon: Palette,
    title: "Design That Feels Like You",
    description:
      "We know your home should reflect who you are. Our designers work with you to create spaces that feel right – whether you love modern minimalism or classic elegance. With thousands of design options, we find what works for you.",
    highlight: "Your Style, Our Expertise",
  },
  {
    icon: Maximize2,
    title: "Making Every Inch Count",
    description:
      "Small space? No problem. We understand the challenge of making compact homes feel spacious. Our designers specialize in layouts that maximize what you have, creating rooms that feel bigger and work better.",
    highlight: "Smart Space Planning",
  },
  {
    icon: Maximize2,
    title: "Storage That Actually Works",
    description:
      "Tired of clutter? We design storage solutions that fit your life. Multi-functional furniture, clever hidden storage, and smart organization – all without sacrificing style. Your home stays beautiful and organized.",
    highlight: "Practical & Beautiful",
  },
  {
    icon: Lightbulb,
    title: "Lighting That Sets the Mood",
    description:
      "The right lighting transforms a space. We help you create the perfect atmosphere – bright and functional where you need it, warm and cozy where you want it. Every room feels just right.",
    highlight: "Atmosphere & Function",
  },
  {
    icon: Layers,
    title: "Ceilings That Add Character",
    description:
      "Don't forget what's above you. Beautiful false ceilings add depth and sophistication to your spaces. We design them with concealed lighting and modern patterns that elevate your entire home.",
    highlight: "Attention to Detail",
  },
  {
    icon: DoorOpen,
    title: "Doors That Make a Statement",
    description:
      "First impressions matter. We design doors that welcome you home and complement your interior style. From sleek modern designs to classic elegance, crafted with care and quality materials.",
    highlight: "Welcome Home",
  },
];

export default function FeaturesShowcase() {
  return (
    <section className="section-spacing bg-background-main">
      <div className="container-custom section-padding">
        <SectionHeading
          label="How We Help"
          title="Everything you need for spaces that work beautifully."
          align="center"
        />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-12">
          {features.map((feature, index) => {
            const IconComponent = feature.icon;
            return (
              <AnimatedSection
                key={feature.title}
                delay={index * 100}
                className="bg-white rounded-3xl p-8 shadow-soft hover:shadow-medium transition-shadow"
              >
                <div className="w-16 h-16 bg-brand-accent/10 rounded-2xl flex items-center justify-center mb-6">
                  <IconComponent className="w-8 h-8 text-brand-accent" />
                </div>
                <span className="text-brand-accent text-sm font-medium uppercase tracking-wider">
                  {feature.highlight}
                </span>
                <h3 className="font-heading text-xl text-brand-primary mt-3 mb-4">
                  {feature.title}
                </h3>
                <p className="text-text-secondary leading-relaxed">
                  {feature.description}
                </p>
              </AnimatedSection>
            );
          })}
        </div>
      </div>
    </section>
  );
}
